export const usersListExternalSteps = [
  {
    selector: "#users-email-search",
    content:
      "Search for users by their email address. Enter a partial or full email to filter the user list.",
  },
  {
    selector: "#users-name-search",
    content:
      "Search for users by their name. This searches across both first and last names.",
  },
  {
    selector: "#client",
    content:
      "Your assigned client is pre-selected. Users shown are limited to those assigned to your client.",
  },
  {
    selector: "#users-disabled-toggle",
    content:
      "Check this box to include disabled users in the search results.",
  },
  {
    selector: "#users-search-button",
    content:
      "Click 'Search' to find users matching your filters.",
  },
  {
    selector: "#users-data-grid",
    content:
      "This table displays users in your organization. Click 'Edit User' to modify user information.",
  },
  {
    selector: "#create-user-button",
    content:
      "Click this button to create a new user account for your organization.",
  },
];
